import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { PieChart as PieChart$1 } from "@mui/x-charts/PieChart";
import { makeValueFormatter } from "../utils/data.js";
const PieChart = t0 => {
  const $ = c(82);
  const {
    chartProps,
    dataset,
    height,
    showLabels: t1,
    isLoading: t2,
    colorScheme: t3,
    labelFormat: t4
  } = t0;
  const showLabels = t1 === void 0 ? false : t1;
  const isLoading = t2 === void 0 ? false : t2;
  const colorScheme = t3 === void 0 ? "sand" : t3;
  const labelFormat = t4 === void 0 ? "share-label" : t4;
  const theme = useTheme();
  const chartHeight = height - 4;
  const pieSize = chartHeight;
  let t5;
  if ($[0] !== dataset) {
    t5 = dataset ?? {};
    $[0] = dataset;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    columns: t6,
    data: t7
  } = t5;
  let t8;
  if ($[2] !== t6) {
    t8 = t6 === void 0 ? [] : t6;
    $[2] = t6;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  const columns = t8;
  let t9;
  if ($[4] !== t7) {
    t9 = t7 === void 0 ? [] : t7;
    $[4] = t7;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  const data = t9;
  let t10;
  if ($[6] !== chartProps.configuration.x.data.key) {
    t10 = chartProps.configuration.x.data.key.split(".").pop() ?? chartProps.configuration.x.data.key;
    $[6] = chartProps.configuration.x.data.key;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const xColKey = t10;
  let t11;
  if ($[8] !== chartProps.series[0]?.data.key) {
    t11 = chartProps.series[0]?.data.key.split(".").pop() ?? "";
    $[8] = chartProps.series[0]?.data.key;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const valColKey = t11;
  let t12;
  bb0: {
    const label = chartProps.series[0]?.label;
    if (!label) {
      t12 = "";
      break bb0;
    }
    t12 = typeof label === "string" ? label : label.key;
  }
  const centerLabel = t12;
  let t13;
  bb1: {
    if (!data.length || !columns.length) {
      let t143;
      if ($[10] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
        t143 = {
          pieData: [],
          total: 0,
          valueFormatter: void 0
        };
        $[10] = t143;
      } else {
        t143 = $[10];
      }
      t13 = t143;
      break bb1;
    }
    let t142;
    if ($[11] !== columns || $[12] !== xColKey) {
      let t153;
      if ($[14] !== xColKey) {
        t153 = c2 => c2.key === xColKey;
        $[14] = xColKey;
        $[15] = t153;
      } else {
        t153 = $[15];
      }
      t142 = columns.findIndex(t153);
      $[11] = columns;
      $[12] = xColKey;
      $[13] = t142;
    } else {
      t142 = $[13];
    }
    const xIdx = t142;
    let t152;
    if ($[16] !== columns || $[17] !== valColKey) {
      let t163;
      if ($[19] !== valColKey) {
        t163 = c_0 => c_0.key === valColKey;
        $[19] = valColKey;
        $[20] = t163;
      } else {
        t163 = $[20];
      }
      t152 = columns.findIndex(t163);
      $[16] = columns;
      $[17] = valColKey;
      $[18] = t152;
    } else {
      t152 = $[18];
    }
    const valIdx = t152;
    if (xIdx === -1 || valIdx === -1) {
      let t163;
      if ($[21] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
        t163 = {
          pieData: [],
          total: 0,
          valueFormatter: void 0
        };
        $[21] = t163;
      } else {
        t163 = $[21];
      }
      t13 = t163;
      break bb1;
    }
    let t162;
    if ($[22] !== colorScheme || $[23] !== theme.charts.pie.colors) {
      t162 = theme.charts.pie.colors[colorScheme] ?? theme.charts.pie.colors.sand ?? [];
      $[22] = colorScheme;
      $[23] = theme.charts.pie.colors;
      $[24] = t162;
    } else {
      t162 = $[24];
    }
    const palette = t162;
    const valCol = columns[valIdx];
    let slices;
    let t172;
    if ($[25] !== data || $[26] !== palette || $[27] !== valIdx || $[28] !== xIdx) {
      let t183;
      if ($[31] !== palette || $[32] !== valIdx || $[33] !== xIdx) {
        t183 = (row, i) => ({
          id: String(row[xIdx]),
          label: String(row[xIdx]),
          value: Number(row[valIdx]) || 0,
          color: palette[i % palette.length] ?? ""
        });
        $[31] = palette;
        $[32] = valIdx;
        $[33] = xIdx;
        $[34] = t183;
      } else {
        t183 = $[34];
      }
      slices = data.map(t183);
      t172 = slices.reduce(_temp, 0);
      $[25] = data;
      $[26] = palette;
      $[27] = valIdx;
      $[28] = xIdx;
      $[29] = slices;
      $[30] = t172;
    } else {
      slices = $[29];
      t172 = $[30];
    }
    const total = t172;
    let t182;
    if ($[35] !== valCol) {
      t182 = makeValueFormatter(valCol);
      $[35] = valCol;
      $[36] = t182;
    } else {
      t182 = $[36];
    }
    const valueFormatter = t182;
    let t192;
    if ($[37] !== slices || $[38] !== total || $[39] !== valueFormatter) {
      t192 = {
        pieData: slices,
        total,
        valueFormatter
      };
      $[37] = slices;
      $[38] = total;
      $[39] = valueFormatter;
      $[40] = t192;
    } else {
      t192 = $[40];
    }
    t13 = t192;
  }
  const {
    pieData,
    total: total_0,
    valueFormatter: valueFormatter_0
  } = t13;
  if (!dataset || isLoading || !data.length) {
    let t142;
    if ($[41] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
      t142 = /* @__PURE__ */jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: 260
      });
      $[41] = t142;
    } else {
      t142 = $[41];
    }
    return t142;
  }
  let t14;
  if ($[42] !== pieSize) {
    t14 = Math.round(pieSize * 0.28);
    $[42] = pieSize;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  const innerRadius = t14;
  let t15;
  if ($[44] !== pieSize) {
    t15 = Math.round(pieSize * 0.46);
    $[44] = pieSize;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  const outerRadius = t15;
  let t16;
  if ($[46] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      width: "100%"
    };
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  let t17;
  if ($[47] !== chartHeight) {
    t17 = {
      width: "100%",
      height: chartHeight,
      gap: _temp2
    };
    $[47] = chartHeight;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== pieSize) {
    t18 = {
      position: "relative",
      width: pieSize,
      height: pieSize,
      flexShrink: 0
    };
    $[49] = pieSize;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== valueFormatter_0) {
    t19 = valueFormatter_0 ? {
      valueFormatter: item => valueFormatter_0(item.value)
    } : {};
    $[51] = valueFormatter_0;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      highlight: "item"
    };
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== innerRadius || $[55] !== outerRadius || $[56] !== pieData || $[57] !== t19) {
    t21 = [{
      type: "pie",
      data: pieData,
      innerRadius,
      outerRadius,
      ...t19,
      paddingAngle: 1,
      cornerRadius: 2,
      highlightScope: t20
    }];
    $[54] = innerRadius;
    $[55] = outerRadius;
    $[56] = pieData;
    $[57] = t19;
    $[58] = t21;
  } else {
    t21 = $[58];
  }
  let t22;
  if ($[59] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== pieSize || $[61] !== t21) {
    t23 = /* @__PURE__ */jsx(PieChart$1, {
      series: t21,
      width: pieSize,
      height: pieSize,
      hideLegend: true,
      skipAnimation: true,
      margin: t22
    });
    $[60] = pieSize;
    $[61] = t21;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== centerLabel || $[64] !== theme) {
    t24 = centerLabel && /* @__PURE__ */jsx(Typography, {
      sx: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: theme.fonts.size.base,
        fontWeight: theme.fonts.weight.normal,
        color: theme.colors.text.primary,
        pointerEvents: "none",
        whiteSpace: "nowrap"
      },
      children: centerLabel
    });
    $[63] = centerLabel;
    $[64] = theme;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== t18 || $[67] !== t23 || $[68] !== t24) {
    t25 = /* @__PURE__ */jsxs(Box, {
      sx: t18,
      children: [t23, t24]
    });
    $[66] = t18;
    $[67] = t23;
    $[68] = t24;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  let t26;
  if ($[70] !== chartHeight || $[71] !== labelFormat || $[72] !== pieData || $[73] !== showLabels || $[74] !== theme || $[75] !== total_0 || $[76] !== valueFormatter_0) {
    t26 = showLabels && pieData.length > 0 && /* @__PURE__ */jsx(Box, {
      sx: {
        flex: "1 1 auto",
        maxHeight: chartHeight,
        overflowY: "auto",
        display: "grid",
        gridTemplateColumns: pieData.length > 6 ? "1fr 1fr" : "1fr",
        alignContent: "center",
        alignSelf: "flex-start",
        marginTop: _temp3,
        gap: _temp4
      },
      children: pieData.map(slice => /* @__PURE__ */jsxs(Stack, {
        direction: "row",
        alignItems: "flex-start",
        sx: {
          gap: "6px"
        },
        children: [/* @__PURE__ */jsx(Box, {
          sx: {
            width: 10,
            height: 10,
            borderRadius: "35%",
            bgcolor: slice.color,
            mt: "2px",
            flexShrink: 0
          }
        }), /* @__PURE__ */jsxs(Stack, {
          children: [/* @__PURE__ */jsx(Typography, {
            sx: {
              fontSize: "0.75rem",
              lineHeight: 1.3,
              color: theme.colors.text.secondary
            },
            children: slice.label
          }), /* @__PURE__ */jsx(Typography, {
            sx: {
              fontSize: "0.7rem",
              lineHeight: 1.2,
              color: theme.colors.text.tertiary
            },
            children: (() => {
              const share = total_0 > 0 ? `${(slice.value / total_0 * 100).toFixed(1)}%` : "";
              const formatted = valueFormatter_0 ? valueFormatter_0(slice.value) : String(slice.value);
              if (labelFormat === "value-label") {
                return formatted;
              }
              if (labelFormat === "combined-label") {
                return share && formatted ? `${share} - ${formatted}` : share || formatted;
              }
              return share;
            })()
          })]
        })]
      }, slice.id))
    });
    $[70] = chartHeight;
    $[71] = labelFormat;
    $[72] = pieData;
    $[73] = showLabels;
    $[74] = theme;
    $[75] = total_0;
    $[76] = valueFormatter_0;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  let t27;
  if ($[78] !== t17 || $[79] !== t25 || $[80] !== t26) {
    t27 = /* @__PURE__ */jsx(Stack, {
      sx: t16,
      children: /* @__PURE__ */jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        sx: t17,
        children: [t25, t26]
      })
    });
    $[78] = t17;
    $[79] = t25;
    $[80] = t26;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  return t27;
};
function _temp(sum, s) {
  return sum + s.value;
}
function _temp2(theme_0) {
  return theme_0.sizes.spacing["08"];
}
function _temp3(theme_1) {
  return theme_1.sizes.spacing["05"];
}
function _temp4(theme_2) {
  return theme_2.sizes.spacing["06"];
}
export { PieChart as default };